import React, { useRef, useLayoutEffect } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { cartSelector } from 'store/cart/selectors';
import { useAfterpayCheckoutWidgetScript } from '../hooks/useAfterpayCheckoutWidgetScript';

export const AfterpayWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
`;


export const AfterpayMethodBlock = (): React.JSX.Element => {
  const widgetDiv = useRef(undefined);
  const { isWidgetReady, createCheckoutWidget } = useAfterpayCheckoutWidgetScript();
  const cart = useSelector(cartSelector);
  const { grand_total } = cart;

  useLayoutEffect(() => {
    if (!isWidgetReady || !widgetDiv?.current) {
      return;
    }

    createCheckoutWidget('#afterpay-checkout-widget', grand_total.toString());
  // TODO: Refactor this dependency
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isWidgetReady, widgetDiv]);
  return (
      <AfterpayWrapper id="afterpay-checkout-widget" ref={widgetDiv} />
  );
};
